/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "common": {
                "nested": {
                  "FilterValue": {
                    "fields": {
                      "all": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "any": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "none": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.FilterValue) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A filter to select resources based on an exact field value. For any given
 * value, the value can only be in one property. Depending on the field, either
 * all properties can be set or only a subset will be available.
 *
 * Refer to the documentation of the field.
 * --
 *
 * SOURCE FilterValue @ squareup/connect/v2/common/filters.proto at 23:1
 */
export const FilterValue = $root.lookupType('squareup.connect.v2.common.FilterValue');
fixType(FilterValue);
Builder.createAndAttachToType(FilterValue);